export default (message, type = 'success') => {
  const toastDiv = document.createElement('div')
  toastDiv.setAttribute('aria-atomic', 'true')
  toastDiv.setAttribute('aria-live', 'assertive')
  toastDiv.setAttribute('role', 'alert')
  toastDiv.classList.add('toast', 'mb-3', 'align-items-center', 'text-white', 'border-0', `bg-${type}`, 'fade', 'hide')
  toastDiv.innerHTML =
    `<div class="d-flex"><div class="toast-body">${message}</div><button aria-label="Close" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" type="button"></button></div></div>`
  toastDiv.addEventListener('hidden.bs.toast', () => {
    toastDiv.remove()
  })
  document.getElementById('flash').appendChild(toastDiv)

  new Toast(toastDiv).show()
}
